import { render, staticRenderFns } from "./PersList.vue?vue&type=template&id=34c4ce48"
import script from "./PersList.vue?vue&type=script&lang=js"
export * from "./PersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports